export default "__VITE_ASSET__bafaa16b__"